import { AppAccent } from 'src/app/core/types/app-accent.type';
import { AppVisualContextService } from '../../services/app-visual-context.service';
import { AfterViewInit, Component, ElementRef, HostBinding, Input, NgZone, OnDestroy, Renderer2, inject } from '@angular/core';

@Component({
  selector: 'app-section-title',
  templateUrl: './section-title.component.html',
  styleUrl: './section-title.component.css',
})
export class SectionTitleComponent implements AfterViewInit, OnDestroy {
  @Input() accent?: AppAccent;
  @Input() showDivider = true;
  private readonly visualContext = inject(AppVisualContextService);
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly zone = inject(NgZone);
  private positionObserver?: MutationObserver;
  @HostBinding('class') get visualClass(): string {
    return this.accent === undefined ? '' : this.visualContext.classForInputs(this.accent);
  }

  ngAfterViewInit(): void {
    const cardBody = this.element.nativeElement.closest('.card-body');
    if (!cardBody) return;

    this.zone.runOutsideAngular(() => {
      const updateDivider = (): void => {
        const first = this.isFirstContent(cardBody);
        const host = this.element.nativeElement;
        if (host.classList.contains('section-title-first-in-card') === first) return;
        if (first) this.renderer.addClass(host, 'section-title-first-in-card');
        else this.renderer.removeClass(host, 'section-title-first-in-card');
      };
      updateDivider();
      this.positionObserver = new MutationObserver(updateDivider);
      this.positionObserver.observe(cardBody, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    });
  }

  ngOnDestroy(): void {
    this.positionObserver?.disconnect();
  }

  private isFirstContent(cardBody: Element): boolean {
    let element: Element | null = this.element.nativeElement;
    while (element && element !== cardBody) {
      let sibling = element.previousSibling;
      while (sibling) {
        if (sibling.nodeType === Node.TEXT_NODE && sibling.textContent?.trim()) return false;
        if (sibling instanceof HTMLElement && !sibling.matches('script, style, template') && !sibling.hidden && getComputedStyle(sibling).display !== 'none') return false;
        sibling = sibling.previousSibling;
      }
      element = element.parentElement;
    }
    return true;
  }

}
